"use strict";
/**
 * @module Services.SessionTrees
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
var session_tree_branch_list_1 = require("./session-tree-branch-list");
/**
 * Serialiser for {@link SessionTreeBranchList}
 */
var SessionTreeBranchListSerialiserClass = /** @class */ (function (_super) {
    __extends(SessionTreeBranchListSerialiserClass, _super);
    function SessionTreeBranchListSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link SessionTreeBranchList} from the stream
     *
     * @param bis  the input stream
     * @return     the {@link SessionTreeBranchList} that was read
     */
    SessionTreeBranchListSerialiserClass.prototype.read = function (bis) {
        var paths = Codec.readCollection(bis, Codec.readString);
        return new session_tree_branch_list_1.SessionTreeBranchList(paths);
    };
    return SessionTreeBranchListSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.SessionTreeBranchListSerialiserClass = SessionTreeBranchListSerialiserClass;
/**
 * The {@link SessionTreeBranchListSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.SessionTreeBranchListSerialiser = new SessionTreeBranchListSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/session-trees/session-tree-branch-list-serialiser.js
// module id = 1452
// module chunks = 0